module.exports = __webpack_public_path__ + "img/2_2-industriale-concessionario-1.c5031901.png";